import React from 'react';
import { t } from 'i18next';
import {
  List,
  Datagrid,
  TextField,
} from 'react-admin';
import { CustomBulkActions } from '../CustomBulkActions';
import { CustomListActions } from '../CustomListActions';

export const ProductGroupList = props => (
  <List {...props} bulkActionButtons={<CustomBulkActions />} actions={<CustomListActions />} title={t('product_groups.title_list')}>
    <Datagrid rowClick="edit">
      <TextField source="name" label={t('name')} />
    </Datagrid>
  </List>
);
